"use client";

import { useMemo } from "react";

import { useConfig } from "@stadium/hooks/lib/use-config";

import TextBannerWithBtnAndBgImg from "@components/widgets/text-banner-with-button-and-bg-img";

import { appendCatalogParamToUrl, getCatalogHeroSliceContent } from "@helpers/catalog";

import { getDefaultShopNumber } from "@selectors/config";

import { getCatalogNavLinkUrl } from "@stadium/shared/src/helpers/store/links";
import { getShopUrl } from "@stadium/helpers/store";
import { CATALOG_SLUG } from "@stadium/constants/shop";
import { DEFAULT_COUNTRY_ISO, MY_WORKSPACE_SLUG } from "@stadium/constants";
import { PROMOTIONAL_STORE_SLUG, SWAGMAGIC_DOMAIN } from "@constants/env-variables";

const SWAGMAGIC_STORE_ORIGIN = SWAGMAGIC_DOMAIN ? `https://${SWAGMAGIC_DOMAIN}` : undefined;

const CatalogHeroSlice = (props) => {
  const defaultShopNumber = useConfig(getDefaultShopNumber);

  const catalogModeStoreUrl = useMemo(() => {
    const storeUrl = getShopUrl({ slug: CATALOG_SLUG, shopNumber: defaultShopNumber });
    return appendCatalogParamToUrl(`${storeUrl}/menu`);
  }, [defaultShopNumber]);

  const buttonsList = useMemo(
    () => [
      {
        button_link: getCatalogNavLinkUrl({
          queryForRoutePath: {
            countryCode: `${DEFAULT_COUNTRY_ISO.toLowerCase()}-en`,
            workspaceSlug: MY_WORKSPACE_SLUG,
            storeIdentifier: PROMOTIONAL_STORE_SLUG,
          },
          baseOrigin: SWAGMAGIC_STORE_ORIGIN,
          isNewRouteEnabled: true,
        }),
        button_text: "browse swagmagic catalog",
        button_style: "primary-outline",
        target: "_blank",
      },
      {
        button_link: catalogModeStoreUrl,
        button_text: "browse all products",
        button_style: "primary",
      },
    ],
    [catalogModeStoreUrl],
  );

  return <TextBannerWithBtnAndBgImg content={getCatalogHeroSliceContent(buttonsList)} {...props} />;
};

export default CatalogHeroSlice;
